<template>
  <article class="blog__item blog__item--big">
    <div class="grid-noGutter">
      <router-link
        ref="thumb"
        :to="{ name: POST_PAGE_NAME, params: { slug: post.slug } }"
        class="col-6_md-12_sm-4 link"
      >
        <bi-picture
          v-if="post.header_type === 'image' && post.header_image"
          :is-legacy="post.header_image.isLegacy"
          :thumb-formats="post.header_image.formats"
          :code="post.header_image.code"
          :thumb-sizes="post.header_image.sizes"
        ></bi-picture>
        <img
          v-if="post.header_type === 'video' && post.header_video"
          class="post-preview"
          :src="post.header_video.preview"
        />
      </router-link>
      <div class="col-6_md-12_sm-8">
        <div class="content">
          <div v-if="post.tags_static" class="category js-reveal">
            <i class="iconmoon-tag"></i>{{ post.tags_static }}
          </div>
          <router-link
            :to="{ name: POST_PAGE_NAME, params: { slug: post.slug } }"
            class="link js-reveal"
          >
            <h1 class="js-cut-header" style="word-wrap: break-word;">
              <span>{{ post.title }}</span>
            </h1>
          </router-link>
          <ul v-if="post.Author" class="js-reveal">
            <li>
              By <span class="author">{{ post.Author.name }}</span>
            </li>
            <li>
              <time>{{ formattedTime(post.published_at) }}</time>
            </li>
          </ul>
          <p
            v-if="post.intro_text_stripped"
            class="hidden--sm js-reveal"
            v-html="sliceContent(post.intro_text_stripped)"
          ></p>
          <router-link
            :to="{ name: POST_PAGE_NAME, params: { slug: post.slug } }"
            class="btn-more hidden--sm js-reveal"
            >READ MORE
            <i class="btn-more-icon iconmoon-arrow_forward"></i>
          </router-link>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import BiPicture from "../BiPicture";
import { POST_PAGE_NAME } from "../../../router/names";
import { parseDate } from "../../../helpers/utils";

export default {
  components: {
    "bi-picture": BiPicture
  },
  props: {
    post: Object
  },
  data() {
    return {
      POST_PAGE_NAME
    };
  },
  methods: {
    formattedTime(time) {
      let date = new Date(time);
      return parseDate(date);
    },
    sliceContent(text) {
      return text.slice(0, 177) + "...";
    }
  }
};
</script>
<style scoped lang="scss" type="text/scss">
.post-preview {
  width: 100%;
}
</style>
